import {
  SET_ACTIVITY_PANEL_ACTIVE_TAB,
  SET_ACTIVITY_PANEL_MESSAGE,
  SET_ACTIVITY_PANEL_TITLE,
  SET_FOCUSED_MESSAGE,
  SET_IS_DEEP_RESEARCH_ENABLED,
  SET_IS_OPEN_AI_ENABLED,
  SET_PROGRESS_CARD_TITLE,
  SET_PROGRESS_PERCENTAGE,
  SET_SELECTED_THREAD_MESSAGES,
  SET_SHOW_ACTIVITY_PANEL,
  SET_SHOW_LOADER,
  SET_SHOW_PROGRESS_CARD,
  SET_USER_QUERY
} from '../actions/deepResearchActions';

export interface IDeepResearchState {
  userQuery: string;
  isDeepResearchEnabled: boolean;
  isOpenAIEnabled: boolean;
  selectedThreadMessages: any;
  focusedMessage: any;
  isLoaderEnabled: boolean;
  showActivityPanel: boolean;
  activityPanelTitle: string;
  activityPanelActiveTab: string;
  isProgressCardVisible: boolean;
  progressCardTitle: string;
  progressPercentage: number;
  activityPanelMessage: any;
}

// Initial State
export const deepResearchInitialState: IDeepResearchState = {
  userQuery: '',
  isDeepResearchEnabled: false,
  isOpenAIEnabled: false,
  selectedThreadMessages: [],
  focusedMessage: null,
  isLoaderEnabled: false,
  showActivityPanel: false,
  activityPanelTitle: '',
  activityPanelActiveTab: 'activity',
  isProgressCardVisible: false,
  progressCardTitle: '',
  progressPercentage: 0,
  activityPanelMessage: null
};

// Reducer
export const deepResearchReducer = (
  state: IDeepResearchState = deepResearchInitialState,
  action: any
): IDeepResearchState => {
  switch (action.type) {
    case SET_USER_QUERY:
      return {
        ...state,
        userQuery: action.payload
      };
    case SET_IS_DEEP_RESEARCH_ENABLED:
      return {
        ...state,
        isDeepResearchEnabled: action.payload
      };
    case SET_IS_OPEN_AI_ENABLED:
      return {
        ...state,
        isOpenAIEnabled: action.payload
      };
    case SET_SHOW_LOADER:
      return {
        ...state,
        isLoaderEnabled: action.payload
      };
    case SET_SHOW_ACTIVITY_PANEL:
      return {
        ...state,
        showActivityPanel: action.payload
      };
    case SET_ACTIVITY_PANEL_TITLE:
      return {
        ...state,
        activityPanelTitle: action.payload
      };
    case SET_ACTIVITY_PANEL_ACTIVE_TAB:
      return {
        ...state,
        activityPanelActiveTab: action.payload
      };
    case SET_SHOW_PROGRESS_CARD:
      return {
        ...state,
        isProgressCardVisible: action.payload
      };
    case SET_PROGRESS_CARD_TITLE:
      return {
        ...state,
        progressCardTitle: action.payload
      };
    case SET_PROGRESS_PERCENTAGE:
      return {
        ...state,
        progressPercentage: action.payload
      };
    case SET_SELECTED_THREAD_MESSAGES:
      return {
        ...state,
        selectedThreadMessages: action.payload
      };
    case SET_FOCUSED_MESSAGE:
      return {
        ...state,
        focusedMessage: action.payload
      };
    case SET_ACTIVITY_PANEL_MESSAGE:
      return {
        ...state,
        activityPanelMessage: action.payload
      };
    default:
      return state;
  }
};
